module.exports = __webpack_public_path__ + "static/media/logo_.e27bddbc.png";